import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import useStore from './store-hook';

const Container = styled.div`
  cursor: pointer;
  width: 100%;
  display: ${props => (props.isCurrent ? 'none' : 'flex')};
  align-items: center;
  font: ${props => props.theme.fontWeightHeavy} 14px/120% ${props => props.theme.fontFamilyBody};
  margin: 10px 0;
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid transparent;
  background-color: ${props => (props.isHighlight ? props.theme.primaryColorTransparent : 'transparent')};

  & > .fa-edit {
    display: none;
    margin-right: -40px;
    margin-left: 20px;
    font-weight: ${props => props.theme.fontWeightBlack};
    font-size: 20px;
    color: ${props => props.theme.primaryColor};
  }

  &:hover {
    border: 1px solid ${props => props.theme.secondaryColorLight};
    box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.25);
    background-color: ${props => props.theme.secondaryColorLightest};

    > .fa-edit {
      display: inline-block;
    }
  }

  & > .category {
    min-width: 280px;
    margin-right: 20px;
    font-size: 12px;
    text-transform: uppercase;
    color: ${props => props.theme.secondaryColor};
  }

  & > .question {
    color: ${props => props.theme.bodyColor};
    font-size: 18px;
    flex-grow: 2;
  }

  & > .types {
    margin-left: 10px;
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    > span {
      margin-left: 10px;
      background-color: ${props => props.theme.secondaryColorLight};
      border-radius: 3px;
      border: 1px solid ${props => props.theme.primaryColor};
      padding: 2px 5px;
      font-size: 12px;
    }

    > span.hoverable:hover, > span.highlight {
      background-color: ${props => props.theme.primaryColor};
      color: white;
    }
  }
`;

export default function Summary({ eventKey, qindex }) {
  const q = useStore(React.useCallback(state => state.qs[qindex], [qindex]));
  const set = useStore(state => state.set);
  const highlighType = useStore(state => state.highlighType);
  const currentKey = React.useContext(AccordionContext);

  const expand = useAccordionToggle(eventKey, () => set(state => {
    state.highlighType = null;
  }));

  const setHighlightType = type => e => {
    if (currentKey) {
      // let it bubble to parent
      return;
    }
    e && e.stopPropagation();
    set(state => {
      state.highlighType = type;
    });
  };

  return (
    <Container
      role="region"
      onClick={expand}
      isCurrent={currentKey === eventKey}
      isHighlight={!!_.find(q.fundTypes, { label: highlighType })}
    >
      <span className="category">{q.category.label}</span>
      <span className="question">{q.description}</span>
      <div className="types">
        {q.fundTypes.map(({ label }) => (
          <span
            role="region"
            className={classNames({ hoverable: !currentKey, highlight: highlighType === label })}
            onClick={setHighlightType(label)}
            key={`type-${label}`}
          >
            {label}
          </span>
        ))}
      </div>
      <i className="fa fa-edit" />
    </Container>
  );
}

Summary.propTypes = {
  eventKey: PropTypes.string.isRequired,
  qindex: PropTypes.number.isRequired,
};
